<script lang="ts" setup>
import { icMonitorHeartOutline } from "@/components/icons";
import ScopeGuard from "@/components/permission/ScopeGuard.vue";
import { Icon } from "@soft-db/ui";

const { t } = useI18n();
</script>

<template>
	<div class="hero">
		<div class="hero-content flex-col">
			<Icon class="text-error size-16" :d="icMonitorHeartOutline" />
			<h1 class="text-center" tag="h1" noTruncate>
				<ScopeGuard scope="distributor">
					{{ t("integrity-settings.selectSiteOrStation") }}
					<template #fallback>
						{{ t("dashboard.selectSite") }}
					</template>
				</ScopeGuard>
			</h1>
		</div>
	</div>
</template>
